import { type FC } from "react";
import styled from "styled-components";
import {
  BILLING_CURRENCY_FILTERS,
  INTERVAL_FILTERS,
  SUBSCRIPTION_LEVEL_FILTERS,
  SUBSCRIPTION_OPTION_FILTERS,
  type PriceCatalogueFilters,
} from "../types";

const FiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
`;

const FilterField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #5a6675;
  min-width: 160px;
`;

const Select = styled.select`
  height: 36px;
  border: 1px solid #dbe3eb;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 13px;
  color: #13273f;
  background: #fff;
`;

interface PriceCatalogueFiltersBarProps {
  filters: PriceCatalogueFilters;
  onChange: (next: PriceCatalogueFilters) => void;
}

const PriceCatalogueFiltersBar: FC<PriceCatalogueFiltersBarProps> = ({
  filters,
  onChange,
}) => {
  const update = (key: keyof PriceCatalogueFilters, value: string) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <FiltersRow>
      <FilterField>
        Subscription option
        <Select
          value={filters.subscriptionOption}
          onChange={(e) => update("subscriptionOption", e.target.value)}
        >
          {SUBSCRIPTION_OPTION_FILTERS.map((option) => (
            <option key={option.value || "all-options"} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </FilterField>
      <FilterField>
        Level
        <Select
          value={filters.subscriptionLevel}
          onChange={(e) => update("subscriptionLevel", e.target.value)}
        >
          {SUBSCRIPTION_LEVEL_FILTERS.map((option) => (
            <option key={option.value || "all-levels"} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </FilterField>
      <FilterField>
        Currency
        <Select
          value={filters.billingCurrency}
          onChange={(e) => update("billingCurrency", e.target.value)}
        >
          {BILLING_CURRENCY_FILTERS.map((option) => (
            <option key={option.value || "all-currencies"} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </FilterField>
      <FilterField>
        Interval
        <Select
          value={filters.interval}
          onChange={(e) => update("interval", e.target.value)}
        >
          {INTERVAL_FILTERS.map((option) => (
            <option key={option.value || "all-intervals"} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </FilterField>
    </FiltersRow>
  );
};

export default PriceCatalogueFiltersBar;
